import React, { Component, ReactNode } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RECAPTCHA_SITE_KEY } from '../../../config';

// See related comment on readme file if you need to upgrade the react-google-recaptcha-v3 version
export class RecaptchaContainer extends Component {
  render(): ReactNode {
    const { children } = this.props;
    return (
      <GoogleReCaptchaProvider
        useRecaptchaNet
        useEnterprise
        reCaptchaKey={RECAPTCHA_SITE_KEY}
        scriptProps={{
          async: true,
          defer: true,
          appendTo: 'head'
        }}
      >
        {children}
      </GoogleReCaptchaProvider>
    );
  }
}